export default {
  'password': 'kata laluan',
  'passwordError': 'Kata laluan ialah 8-20 digit, dan hanya menyokong tiga atau lebih kombinasi huruf besar dan kecil, nombor dan simbol',
  'passwordAgain': 'Mengesahkan kata laluan',
  'passwordNotSame': 'Kata laluan yang dimasukkan tidak konsisten. Sila masukkan semula',
  'requiredVerifyCode': 'Masukkan kod',
  'verifyCode': 'Ralat kod pengesahan'
}
